import React from 'react';
import { useFooterLegalLinks } from '../hooks/useFooterLegalLinks';

/**
 * Single-source Legal Footer used across marketing / public surfaces
 * and the site-wide Footer's Legal column. Never embeds legal copy —
 * rendered bodies come from the Agreement Engine via CMSContent.
 *
 * LEGAL-PUBLIC-FOOTER-PROCESS-02 — the Legal footer contains ONLY canonical
 * legal DOCUMENTS supplied dynamically from the `public_legal_footer`
 * process binding (SSOT). No hard-coded functional/informational links.
 */
export const LegalFooter = ({ className = '' }) => {
  const { items: legalDocs } = useFooterLegalLinks();
  return (
    <footer
      data-testid="legal-footer"
      className={`border-t border-slate-200 bg-white text-slate-600 ${className}`}
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-6">
          <div>
            <div className="text-sm font-semibold text-slate-900" data-testid="footer-legal-heading">
              Legal
            </div>
            <ul className="mt-3 grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-2 text-sm" data-testid="legal-footer-links">
              {legalDocs.map((d) => (
                <li key={d.content_key}>
                  <a
                    href={`/legal/${d.content_key}`}
                    data-testid={`legal-footer-doc-${d.content_key}`}
                    className="hover:text-slate-900 hover:underline underline-offset-4"
                  >
                    {d.title}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div className="text-xs text-slate-500 md:text-right">
            <div>© {new Date().getFullYear()} TreatX</div>
            <div className="mt-1">treatx.health</div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default LegalFooter;
